import * as React from 'react'
import { MatchPair } from '../MatchPair'
import { MatchClasses, State, Dispatch } from '../hooks'
import { MatchProps } from '../typings'

import Typography from '@mui/material/Typography'

type Props = MatchProps & {
  state: State
  dispatch: Dispatch
  classes: MatchClasses
}

export const ServiceLocations: React.FC<Props> = (props) => {
  const { classes, state, dispatch, serviceLocations } = props

  return (
    <>
      <Typography sx={classes.svcLocTitle}>
        Match Related Service Locations
      </Typography>

      {serviceLocations.map((l) => (
        <MatchPair
          key={l.id}
          {...props}
          location={l}
          styles={classes}
          state={state}
          dispatch={dispatch}
        />
      ))}
    </>
  )
}
ServiceLocations.displayName = 'ServiceLocations'
